import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import {
  RefreshCw as RefreshIcon,
  CheckSquare as ReleaseIcon,
  DollarSign as PayIcon
} from 'react-feather';
import { COMMISSION_STATUS_OPTIONS } from '../../utils/commissionStatus';

const CommissionsListToolbar = ({
  status,
  setStatus,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  onRefresh,
  onBulkRelease,
  onBulkPay,
  bulkMode,
  selectedCount,
  isAdmin,
  ...props
}) => (
  <Box {...props}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        flexWrap: 'wrap'
      }}
    >
      {isAdmin && bulkMode === 'release' && selectedCount > 0 && (
        <Button color="primary" variant="contained" startIcon={<ReleaseIcon />} onClick={onBulkRelease}>
          Liberar Selecionadas ({selectedCount})
        </Button>
      )}
      {isAdmin && bulkMode === 'pay' && selectedCount > 0 && (
        <Button color="primary" variant="contained" startIcon={<PayIcon />} onClick={onBulkPay}>
          Marcar como Pagas ({selectedCount})
        </Button>
      )}
      <Button color="primary" variant="contained" startIcon={<RefreshIcon />} onClick={onRefresh}>
        Atualizar
      </Button>
    </Box>
    <Box sx={{ mt: 3 }}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Status</InputLabel>
                <Select label="Status" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <MenuItem value="">Todos</MenuItem>
                  {COMMISSION_STATUS_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Data Inicial"
                name="date_from"
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Data Final"
                name="date_to"
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  </Box>
);

CommissionsListToolbar.propTypes = {
  status: PropTypes.string,
  setStatus: PropTypes.func,
  dateFrom: PropTypes.string,
  setDateFrom: PropTypes.func,
  dateTo: PropTypes.string,
  setDateTo: PropTypes.func,
  onRefresh: PropTypes.func,
  onBulkRelease: PropTypes.func,
  onBulkPay: PropTypes.func,
  bulkMode: PropTypes.oneOf(['release', 'pay', null]),
  selectedCount: PropTypes.number,
  isAdmin: PropTypes.bool
};

export default CommissionsListToolbar;
